<ng-container *transloco="let t;">

  <!-- CALENDAR  -->
  <div class="p-grid appointments" [ngClass]="{'in-edit': inEdit === true}">
    <div [ngClass]="{'p-col-12 p-xl-6': size === 2, 'p-col-12 p-xl-4': size === 3}" *ngFor="let month of months">
      <p-calendar [ngModel]="month" [inline]="true" [showWeek]="false" [firstDayOfWeek]="1" [disabledDays]="(isAvailabilityMode()) ? [6,0]: []" [showOtherMonths]="false" [minDate]="calandarMinDate">
        <ng-template pTemplate="date" let-date>
          <div class="marked" [ngClass]="getDayClass(date)" (click)="onDayClicked($event, date)" [pTooltip]="getDayTooltip(date)" tooltipPosition="top">
            <span>{{date.day}}</span>
          </div>
        </ng-template>
      </p-calendar>
    </div>
  </div>

  <!--  -->
  <div class="p-grid">
    <div class="p-col-3">
      <button pButton type="button" [icon]="'pi pi-chevron-left'" class="p-button-secondary p-button-outlined p-mr-2" [disabled]="isFirstMonth() ? true : null" (click)="previousMonth()"></button>
      <button pButton type="button" [icon]="'pi pi-chevron-right'" class="p-button-secondary p-button-outlined" [disabled]="isLastMonth() ? true : null" (click)="nextMonth()"></button>
    </div>
    <div class="p-col-9 p-text-right" *ngIf="type === AppointmentCalendarType.Dates && inEdit === true">
      <div class="p-mt-2">
        <p-selectButton [options]="dayModeOptions" [(ngModel)]="dayMode" optionLabel="name"></p-selectButton>
      </div>
    </div>
    <ng-container *ngIf="type === AppointmentCalendarType.Availabilities && inEdit === true">
      <div class="p-col-6 p-text-right">
        <div class="p-mt-2 click-mode">
          {{t('appointments.calendar.advanced_mode_info')}}
        </div>
      </div>
      <div class="p-col-3 p-text-right">
        <div class="p-mt-2 click-mode">
          <p-selectButton [options]="clickModeOptions" [(ngModel)]="clickMode" optionLabel="name" (onChange)="onClickModeChange($event)"></p-selectButton>
        </div>
      </div>
    </ng-container>
  </div>

  <p-menu #menu [popup]="true" [model]="items"></p-menu>

  <p-dialog [(visible)]="settingsVisible" [draggable]="false" [resizable]="false" [modal]="true" [closable]="false" [style]="{width: '50vw'}">
    <p-header>
      <span>{{ t('common.labels.settings') }}</span>
    </p-header>
    <form class="settings-form" (submit)="saveSettings()">
      <div class="p-grid">
        <div class="p-col-5">
          <h2>{{ t('common.labels.day') }}</h2>
          <div style="margin-top: 15px;">
            <app-form-control [cid]="'daytype'" [control]="settingsForm.get('daytype')" [type]="'select'" [options]="optionsDayType" [showLabel]="false"></app-form-control>
          </div>
          <p class="p-text-small" [innerHtml]="t('appointments.calendar.timing_info', {full: timingInfo.full,  morning: timingInfo.morning, afternoon: timingInfo.afternoon })"></p>
        </div>
        <div class="p-col-2"></div>
        <div class="p-col-5">
          <h2>{{ t('common.labels.locations') }}</h2>
          <ul>
            <li *ngFor="let location of locations">
              <div class="p-grid">
                <div class="p-col-3">
                  <p-checkbox *ngIf="location.control" [name]="location.name" [formControl]="location.control" binary="true"></p-checkbox>
                </div>
                <div class="p-col-9">
                  {{ location.name }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </form>
    <p-footer>
      <button (click)="cancelSettings()" pButton type="button" label="{{ t('common.labels.cancel') }}" class="p-button-outlined p-mr-2"></button>
      <button (click)="saveSettings()" pButton type="button" label="{{ t('common.labels.save') }}"></button>
    </p-footer>
  </p-dialog>

  <p-dialog [(visible)]="holidaySettingsVisible" [draggable]="false" [resizable]="false" [modal]="true" [closable]="false" [style]="{width: '50vw'}">
    <p-header>
      <span>{{ t('common.labels.create_holiday') }}</span>
    </p-header>
    <form class="settings-form" (submit)="saveHolidaySettings()">
      <div class="p-grid">
        <div class="p-col-5">
          <h2>{{ t('common.labels.name') }}</h2>
          <div style="margin-top: 15px;">
            <app-form-control [cid]="'name'" [control]="holidaySettingsForm.get('name')" [type]="'input'" [showLabel]="false"></app-form-control>
          </div>
        </div>
        <div class="p-col-2"></div>
        <div class="p-col-5">
          <h2>{{ t('common.labels.states') }}</h2>
          <ul>
            <li *ngFor="let state of optionsStates">
              <div class="p-grid">
                <div class="p-col-3">
                  <p-checkbox *ngIf="state.control" [name]="state.name" [formControl]="state.control" binary="true"></p-checkbox>
                </div>
                <div class="p-col-9">
                  {{ t('common.states.' + state.name) }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </form>
    <p-footer>
      <button (click)="cancelHolidaySettings()" pButton type="button" label="{{ t('common.labels.cancel') }}" class="p-button-outlined p-mr-2"></button>
      <button (click)="saveHolidaySettings()" pButton type="button" label="{{ t('common.labels.save') }}"></button>
    </p-footer>
  </p-dialog>

</ng-container>
